<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">

            <span> تخلیه فیلم ها </span>

        </a>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <div class="border border-2 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-md-11 col-12">

                <input class="w-100 h-100 form-control" placeholder="جستجو کنید ..."
                    (keyup)="filter_list($event.target)">

            </div>

            <div class="col-md-1 col-12 px-1">

                <button class="w-100 h-100 btn btn-success" (click)="openAddModal()">

                    افزودن

                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 160px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center"> کد پارکینگ </th>

                        <th class="text-center"> شهر </th>

                        <th class="text-center"> نام پارکینگ </th>

                        <th class="text-center"> نوع پارکینگ </th>

                        <th class="text-center"> ظرفیت </th>

                        <th class="text-center"> تعداد جایگاه شارژ </th>

                        <th class="text-center"> تعداد طبقه </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Parking;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <i class="fa fa-edit mx-2 fa-lg text-primary pointer" title=" ویرایش" (click)="openAddModal(item,index)"></i>

                            <i class="fa fa-trash fa-lg text-danger pointer" title="حذف" (click)="removeItem(item,index)"></i>

                        </th>

                        <td> {{ item.iVS_Parking | faNum }} </td>

                        <td> {{ item.strCityName | faNum }} </td>

                        <td> {{ item.strName | faNum }} </td>

                        <td> {{ item.strParkingType | faNum }} </td>

                        <td> {{ item.iCapacity | number:'1.0-0' | faNum }} </td>

                        <td> {{ item.iChargingStation | number:'1.0-0' | faNum }} </td>

                        <td> {{ item.iFloor | number:'1.0-0' | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- مدال افزودن، ویرایش -->

<div class="modal fade" id="add_Modal">

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title"> {{ editMode ? 'ویرایش پارکینگ' : 'افزودن پارکینگ' }}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="max-height: 76vh;overflow: auto;">

                <div [formGroup]="mdl_Add" class="row gx-2 gy-2 p-2">

                    <!-- * شهر -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> * شهر </label>

                        <custom-filter *ngIf="list_City.length"

                            [strValue]="returnStrValue('strCity',mdl_Add.get('strCity')?.value,list_City,'strCityName')"
                    
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: center']"
                    
                            [str_Placeholder]="'نام شهر را جستجو کنید'"
                    
                            [lst_Main]="list_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="false"
                            
                            (hideOptions)="mdl_Add.get('strCity')?.setValue($event?.strCity ? $event.strCity : '')">
                
                        </custom-filter>

                    </div>

                    <!-- * کد -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> * کد </label>

                        <input class="form-control p-2 text-center" formControlName="strCode">

                    </div>

                    <!-- * نام -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> * نام </label>

                        <input class="form-control p-2 text-center" formControlName="strName">

                    </div>

                    <!-- * آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> * آدرس </label>

                        <input class="form-control p-2 text-center" formControlName="strAddress">

                    </div>

                    <!-- * نوع -->

                    <div class="col-12 col-md-3 position-relative p-2">

                        <label class="mb-2 text-muted"> * نوع </label>

                        <select class="form-select p-2" formControlName="tiParkingType">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" value="0"> مسقف </option>

                            <option class="text-center" value="1"> روباز </option>

                            <option class="text-center" value="2"> ترکیبی </option>

                        </select>

                    </div>

                    <!-- * تعداد طبقه -->

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> * تعداد طبقه </label>

                        <input class="form-control p-2 text-center" formControlName="iFloor">

                    </div>

                    <!-- * ظرفیت  -->

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> * ظرفیت </label>

                        <input class="form-control p-2 text-center" formControlName="iCapacity">

                    </div>

                    <!-- * تعداد جایگاه شارژ -->

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> * تعداد جایگاه شارژ </label>

                        <input class="form-control p-2 text-center" formControlName="iChargingStation">

                    </div>

                    <!-- * وضعیت مالکیت -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> * وضعیت مالکیت </label>

                        <select class="form-select p-2" formControlName="tiOwnershipStatus">

                            <option class="text-center" value=""> انتخاب کنید </option>

                            <option class="text-center" value="0"> ملکی </option>

                            <option class="text-center" value="1"> استیجاری </option>

                        </select>

                    </div>

                    <!-- * تاریخ شروع اجاره -->

                    <ng-container *ngIf="mdl_Add.get('tiOwnershipStatus')?.value == 1">
                        
                        <div class="col-12 col-md-4 position-relative p-2">
                            
                            <label> * تاریخ شروع اجاره </label>
                            
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
                                
                                <input type="text" class="form-control p-2 text-end" formControlName="strSContractDate" />
                                
                            </ng-persian-datepicker>
                            
                        </div>
                        
                    </ng-container>

                    <!-- * تاریخ پایان اجاره -->

                    <ng-container *ngIf="mdl_Add.get('tiOwnershipStatus')?.value == 1">

                        <div class="col-12 col-md-4 position-relative p-2">

                            <label> * تاریخ پایان اجاره </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" class="form-control p-2 text-end" formControlName="strEContractDate"/>

                            </ng-persian-datepicker>

                        </div>

                    </ng-container>

                    <!-- * IP Station -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> * IP Station </label>

                        <input class="form-control p-2 text-end" formControlName="strIP" style="direction: ltr;">

                    </div>

                    <!-- * Media Path -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> * Media Path </label>

                        <input class="form-control p-2 text-end" formControlName="strMediaPath" style="direction: ltr;">

                    </div>

                    <!-- فعال -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bActive" formControlName="bActive">

                        <label class="form-check-label pointer text-muted me-2" for="bActive"> فعال </label>

                    </div>

                    <!-- توضیحات -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strComment"></textarea>

                    </div>

                    <!-- تعیین محدوده -->

                    <div class="col-12 p-2">

                        <ng-container *ngIf="mdl_Add.get('lstPoints')?.value != ''">

                            <button class="btn btn-info ms-2" (click)="showArea()"> 
        
                                مشاهده محدوده
                                
                            </button>

                        </ng-container>

                        <button class="btn btn-warning" (click)="openAreaMap()"> 

                            {{ editMode ? 'ویرایش محدوده' : 'تعیین محدوده' }}
                            
                        </button>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button [ngClass]="editMode ? 'btn btn-primary' : 'btn btn-success' " (click)="submitRequest()">

                    &nbsp; {{ editMode ? 'ویرایش' : 'ثبت' }} &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal"> 

                    بستن
                    
                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال محدوده نقشه -->

<div class="modal fade" id="mapArea_Modal">

        <div class="modal-dialog modal-fullscreen modal-fullscreen-sm-down">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title"> محدوده پارکینگ </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="max-height: 86vh;overflow: auto;">

                <div id="test" class="position-sticky w-100" style="height: 80vh;" [ngStyle]="{'pointer-events': mapShowMode ? 'none' : ''}">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

                </div>

            </div>

            <div class="modal-footer">

                <button class="btn btn-warning" (click)="changeTail()">

                    تغییر نوع نقشه
                    
                </button>

                <ng-container *ngIf="!mapShowMode">

                    <button class="btn btn-success mx-2" data-bs-dismiss="modal">
    
                        &nbsp; ثبت &nbsp;
    
                    </button>

                </ng-container>
                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal"> 

                    بستن
                    
                </button>

            </div>

        </div>

    </div>

</div>
